import { render, staticRenderFns } from "./AccountFacebook.vue?vue&type=template&id=f24a323e&scoped=true&"
import script from "./AccountFacebook.vue?vue&type=script&lang=js&"
export * from "./AccountFacebook.vue?vue&type=script&lang=js&"
import style0 from "./AccountFacebook.vue?vue&type=style&index=0&id=f24a323e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f24a323e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/admin/workspace/ss/ss-web-game/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f24a323e')) {
      api.createRecord('f24a323e', component.options)
    } else {
      api.reload('f24a323e', component.options)
    }
    module.hot.accept("./AccountFacebook.vue?vue&type=template&id=f24a323e&scoped=true&", function () {
      api.rerender('f24a323e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/social/AccountFacebook.vue"
export default component.exports